import styled from 'styled-components';

export const ShadowWrap = styled.div`
    box-shadow: 4px 4px 10px rgba(102, 113, 127, 0.1);
    background-color: ${(props) => props.theme.colors.senary};
    position: relative;
`;
